import { Link } from 'gatsby'
import React from 'react'
import styled from 'styled-components'
import { Avatar } from './Avatar'

const Wrapper = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
  margin-right: var(--spacing-4);
  color: var(--link-color);
  &:hover {
    color: var(--link-color-hover);
  }
`

export const DisplayName = styled.span`
  margin-left: var(--spacing-2);
  font-weight: bold;
`

export const PostAuthor = ({ displayName, avatarImage, slug }) => {
  return (
    <Wrapper to={slug}>
      <Avatar image={avatarImage} alt={displayName} />
      <DisplayName>{displayName}</DisplayName>
    </Wrapper>
  )
}
